import { ProductAlert, User, ToastState, FileType, UserType } from 'types';
import * as React from 'react';
import {
  getAlerts,
  createAlert,
  updateAlert,
  AlertSortSpecification,
  downloadAlertFile,
} from 'services/ProductAlertService';
import { Redirect } from 'react-router-dom';
import AlertList from 'views/Alerts/AlertList';
import { getNewPageIndex } from '../../helpers/pagination';
import { UserService } from 'services/ApiService';
import './Alerts.scss';
import DropdownButton from 'components/Dropdown/DropdownButton';
import DropdownContentDiv from 'components/Dropdown/DropdownContentDiv';
import {
  EXPORT_ALL_MESSAGE,
  EXPORT_FILTERED_MESSAGE,
  EXPORT_VISIBLE_MESSAGE,
  ExportMode,
  isExportMode,
} from 'helpers/export';
// import { MouseEvent } from "react";
import AlertModal from 'views/Alerts/AlertModal';
import Toast from 'components/Toast';

type AlertDisplayProps = {};

/** Modes in which the alert form might be. */
enum FormMode {
  /** The form is editing an existing alert */
  Editing,
  /** The form is creating a new claim */
  Creating,
  /** The form isn't being displayed. */
  None,
}

export const DEFAULT_PAGE_SIZE = 50;

type AlertDisplayState = {
  /** The alerts to display. Null while they are being fetched. */
  alerts: ProductAlert[] | null;
  /** The 0-based index of the page being displayed. */
  currentPageIndex: number;
  /** The number of alert records to display per page. */
  alertsPerPage: number;
  /** The total number of pages of alerts available. */
  numPages: number;
  /** The currently authenticated user. Ideally, this would be
   * held elsewhere, but this isn't the case with the existing user service.
   */
  user: User | null;
  /** True while alerts are loading, false otherwise. */
  isLoading: boolean;
  /** The alert currently being displayed on the alert form, if any. */
  currentAlert: null | ProductAlert;
  /** True while alerts are being saved, false otherwise.
   * Used to prevent multiple submissions of an alert, as well as for downstream disabling
   * of the alert form input elements.
   */
  isSavingAlert: boolean;
  /** The state of the alert form. */
  alertFormMode: FormMode;
  /** The current sort specification. */
  sortSpecification: null | AlertSortSpecification;
  /** Whether to redirect to a specific alert page */
  redirectToAlertPage: null | ProductAlert;
  /** Whether to create a new alert page */
  redirectToNewAlertPage: boolean;
  /** State of status filters */
  filters: { id: string; value: any }[] | null;
  /** Whether to hide archived alerts */
  hideArchivedAlerts: boolean;
};

export default class AlertDisplay extends React.Component<
  AlertDisplayProps,
  AlertDisplayState
> {
  private previousUser: User | null = null;
  // private handleCSVExport = AlertDisplay.exportModeGuard.bind(
  //   this,
  //   this.exportToCSV
  // );
  // private handlePDFExport = AlertDisplay.exportModeGuard.bind(
  //   this,
  //   this.exportToPDF
  // );

  /**
   * Verifies the value of the export mode for the event target and then calls the callback function with the verified
   * and casted value.
   * @param callback The function to be invoked with the verified and casted value.
   * @param event The event object for whatever event has just occurred.
   */
  // private static exportModeGuard(
  //   callback: (mode: ExportMode) => void,
  //   event: MouseEvent<HTMLDivElement>
  // ): void {
  //   /* In more recent versions of TypeScript, replace the cast below with:
  //    * (event.target as { value: unknown }).value  */
  //   const value = (event.target as any).value;
  //   if (isExportMode(value)) {
  //     callback(value);
  //   }
  // }

  private static shouldShowAlertForm(
    newAlert: AlertDisplayState['currentAlert']
  ): newAlert is ProductAlert {
    return newAlert !== null;
  }

  constructor(props: AlertDisplayProps) {
    super(props);
    this.state = {
      alerts: null,
      isLoading: true,
      currentPageIndex: 0,
      alertsPerPage: DEFAULT_PAGE_SIZE,
      numPages: 0,
      user: null,
      currentAlert: null,
      isSavingAlert: false,
      alertFormMode: FormMode.None,
      sortSpecification: null,
      redirectToAlertPage: null,
      redirectToNewAlertPage: false,
      filters: null,
      hideArchivedAlerts: true,
    };

    this.handlePageSet = this.handlePageSet.bind(this);
    this.handlePageSizeSet = this.handlePageSizeSet.bind(this);
    this.exportAlerts = this.exportAlerts.bind(this);
    this.createAlert = this.createAlert.bind(this);
    this.updateAlert = this.updateAlert.bind(this);
    this.setNewAlert = this.setNewAlert.bind(this);
    this.showAlertForm = this.showAlertForm.bind(this);
    this.showAlertPage = this.showAlertPage.bind(this);
    this.hideAlertForm = this.hideAlertForm.bind(this);
    this.showNewAlertForm = this.showNewAlertForm.bind(this);
    this.setSort = this.setSort.bind(this);
    this.handleTableFiltersChanged = this.handleTableFiltersChanged.bind(this);
  }

  componentDidMount() {
    this.fetchUser();
  }

  componentDidUpdate() {
    if (this.previousUser !== this.state.user) {
      this.fetchAlerts();
      this.previousUser = this.state.user;
    }
  }

  render() {
    return (
      <div className="alerts">
        {this.state.redirectToAlertPage && (
          <Redirect
            to={{
              pathname: `alerts/${
                this.state.redirectToAlertPage &&
                this.state.redirectToAlertPage.id
              }`,
              state: { alert: this.state.redirectToAlertPage },
            }}
          />
        )}
        {this.state.redirectToNewAlertPage && (
          <Redirect
            to={{
              pathname: `alerts/new`,
              state: { newAlert: true },
            }}
          />
        )}
        <div className="alerts-heading-actions">
          <span className="main-actions">
            <h1 className="alerts-title">{this.state.user && this.state.user.type !== UserType.QAAdmin && 'Wine Floor Price '}Alerts</h1>
            <div className="displayArchivedAlerts">
              <input
                type="checkbox"
                onChange={() => this.toggleArchivedAlerts()}
                defaultChecked={this.state.hideArchivedAlerts}
              />
              <label>&nbsp;Hide Archived Alerts</label>
            </div>
            <button
              className="heading-button heading-action"
              onClick={this.showNewAlertForm}
            >
              Add Alert
            </button>
          </span>
          <span className="export-buttons">
            {/* TODO RECALLS MODULE: just like with the claims page, only two of the buttons
                        in the following dropdowns should be contextually displayed
                        based on whether or not the user has applied any filters. This
                        needs to be implemented still. */}
            <DropdownButton
              className="heading-button heading-action"
              label="Export to CSV"
            >
              <DropdownContentDiv
                onClick={(e) =>
                  this.exportAlerts((e.target as any).value, FileType.CSV)
                }
              >
                {this.state.filters !== null &&
                this.state.filters.some((filter) => filter.value !== null) ? (
                  <button
                    className="heading-button inner-dropdown"
                    value={ExportMode.Filtered}
                  >
                    {EXPORT_FILTERED_MESSAGE}
                  </button>
                ) : (
                  <button
                    className="heading-button inner-dropdown"
                    value={ExportMode.All}
                  >
                    {EXPORT_ALL_MESSAGE}
                  </button>
                )}
                <button
                  className="heading-button inner-dropdown"
                  value={ExportMode.Visible}
                >
                  {EXPORT_VISIBLE_MESSAGE}
                </button>
              </DropdownContentDiv>
            </DropdownButton>
            <DropdownButton
              className="heading-button heading-action"
              label="Export to PDF"
            >
              <DropdownContentDiv
                onClick={(e) =>
                  this.exportAlerts((e.target as any).value, FileType.PDF)
                }
              >
                {this.state.filters !== null &&
                this.state.filters.some((filter) => filter.value !== null) ? (
                  <button
                    className="heading-button inner-dropdown"
                    value={ExportMode.Filtered}
                  >
                    {EXPORT_FILTERED_MESSAGE}
                  </button>
                ) : (
                  <button
                    className="heading-button inner-dropdown"
                    value={ExportMode.All}
                  >
                    {EXPORT_ALL_MESSAGE}
                  </button>
                )}
                <button
                  className="heading-button inner-dropdown"
                  value={ExportMode.Visible}
                >
                  {EXPORT_VISIBLE_MESSAGE}
                </button>
              </DropdownContentDiv>
            </DropdownButton>
          </span>
        </div>
        <AlertList
          alerts={this.state.alerts}
          isLoading={this.state.isLoading}
          currentPage={this.state.currentPageIndex}
          pageSize={this.state.alertsPerPage}
          setPage={this.handlePageSet}
          setPageSize={this.handlePageSizeSet}
          numPages={this.state.numPages}
          showAlert={this.showAlertPage}
          setSortSpecification={this.setSort}
          handleTableFiltersChanged={this.handleTableFiltersChanged}
        />
        {AlertDisplay.shouldShowAlertForm(this.state.currentAlert) && (
          <AlertModal
            alert={this.state.currentAlert}
            setAlert={this.setNewAlert}
            onCancel={this.hideAlertForm}
            onSubmit={
              this.state.alertFormMode === FormMode.Creating
                ? this.createAlert
                : this.updateAlert
            }
            disabled={this.state.isSavingAlert}
            isNewAlert={this.state.alertFormMode === FormMode.Creating}
          />
        )}
      </div>
    );
  }

  private async handleTableFiltersChanged(
    filters: { id: string; value: any }[]
  ): Promise<void> {
    console.log(filters);
    this.setState({ filters });
    await this.fetchAlerts(
      this.state.currentPageIndex,
      this.state.alertsPerPage,
      this.state.sortSpecification,
      filters
    );
  }

  private async exportAlerts(
    mode: ExportMode,
    fileType: FileType
  ): Promise<void> {
    const MAX_VALUE = 2147483647;
    if (this.state.user && isExportMode(mode)) {
      this.setState({ isLoading: true });
      downloadAlertFile(
        {
          fileType,
          mode,
          page: this.state.currentPageIndex,
          pageSize:
            ExportMode[mode] === 'All' ? MAX_VALUE : this.state.alertsPerPage,
          sort: this.state.sortSpecification || undefined,
          filters: this.state.filters,
          hideArchived: this.state.hideArchivedAlerts,
        },
        this.state.user
      )
        .then(() => {
          this.setState({ isLoading: false });
        })
        .catch((err) => {
          Toast.throw({ message: 'Could not export alerts' });
        });
    }
  }

  private async fetchUser(): Promise<void> {
    this.setState({
      user: await UserService.fetch(),
    });
  }

  private async fetchAlerts(
    page: number = this.state.currentPageIndex,
    pageSize: number = this.state.alertsPerPage,
    sortSpecification: AlertSortSpecification | null = this.state
      .sortSpecification,
    filters: { id: string; value: any }[] | null = this.state.filters,
    hideArchived: boolean = this.state.hideArchivedAlerts
  ): Promise<void> {
    if (this.state.user) {
      this.setState({ isLoading: true });
      const {
        numPages,
        currentPage,
        results: alerts,
      } = await getAlerts(
        { page, pageSize, sort: sortSpecification || undefined, filters, hideArchived },
        this.state.user
      );
      this.setState({
        currentPageIndex: currentPage,
        alertsPerPage: pageSize,
        alerts,
        numPages: numPages,
        isLoading: false,
        sortSpecification,
      });
    }
  }

  private setSort(specification: AlertSortSpecification): void {
    this.fetchAlerts(undefined, undefined, specification);
  }

  private async createAlert(): Promise<void> {
    this.submitAlert(createAlert);
  }

  private async updateAlert(changes: Partial<ProductAlert>): Promise<void> {
    this.submitAlert((currentAlert) => updateAlert(currentAlert.id, changes));
  }

  private async submitAlert(
    performSubmission: (currentAlert: ProductAlert) => Promise<any>
  ): Promise<void> {
    if (this.state.currentAlert !== null && !this.state.isSavingAlert) {
      this.setState({ isSavingAlert: true });
      try {
        await performSubmission(this.state.currentAlert);
        Toast.present({ message: 'Alert published!' }, ToastState.SUCCESS);
        /* We'll wait on fetching the alerts so that the user isn't presented with outdated information upon 
                being released back to the table. */
        await this.fetchAlerts();
        this.hideAlertForm();
      } catch (error) {
        if (error.response && error.response.status === 409) {
          Toast.throw({
            message: `Alert number ${this.state.currentAlert.alertNumber} has already been filed!`,
          });
        }
      }
      this.setState({ isSavingAlert: false });
    }
  }

  private handlePageSet(newPageIndex: number): void {
    this.fetchAlerts(newPageIndex);
  }

  private setNewAlert(currentAlert: ProductAlert | null): void {
    this.setState({ currentAlert });
  }

  private handlePageSizeSet(newPageSize: number): void {
    this.fetchAlerts(
      getNewPageIndex(
        this.state.currentPageIndex,
        this.state.alertsPerPage,
        newPageSize
      ),
      newPageSize
    );
  }

  private hideAlertForm(): void {
    this.setState({ currentAlert: null });
  }

  private showNewAlertForm(): void {
    this.setState({ redirectToNewAlertPage: true });
  }
  private showAlertForm(alert?: ProductAlert): void {
    let formMode = FormMode.Editing;
    if (!alert) {
      alert = ProductAlert.defaultAlert(this.state.user || undefined);
      formMode = FormMode.Creating;
    }
    this.setState({ currentAlert: alert, alertFormMode: formMode });
  }
  private showAlertPage(alert: ProductAlert): void {
    this.setState({ redirectToAlertPage: alert });
  }
  private async toggleArchivedAlerts(): Promise<void> {
    let isHidden = this.state.hideArchivedAlerts;
    this.setState({ hideArchivedAlerts: !isHidden });
    await this.fetchAlerts(
      this.state.currentPageIndex,
      this.state.alertsPerPage,
      this.state.sortSpecification,
      this.state.filters,
      !isHidden,
    );
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/views/Alerts/index.tsx